/*
* @link https://blog.armin-pfaeffle.de/2015/07/javascript-transform-slug-to-camel-case/
* ? Convert body class slug to proper javascript class filenames
*/
String.prototype.slugToCamelCase = function(separators) {
	if (!separators || typeof separators != "string") {
		separators = "-_.";
	}
	let result = this.replace(
		new RegExp("[" + separators + "][a-z]", "ig"),
		function(s) {
			return s.substr(1, 1).toUpperCase();
		}
	);

	/**
		* Rules
		* 1. Remove amplus from the slug name
		* 2. Capitalize the first char
		*/
	result = result.replace("amplus-", "");
	result = result.charAt(0).toUpperCase() + result.slice(1);

	return result;
};